import React from 'react'
import { Link } from 'react-router-dom'


const BackButton = () => {
    return (
        <Link to="/admin-page" className='back-button'>
          <button>Regresar</button>
        </Link>
      );
}

export default BackButton